import { AgreeableClientOptions } from 'agreeable-client';
import { leaderModule } from './agreeable-leader';

export const agreeableOptions: Partial<AgreeableClientOptions> = {
  defaultTextType: 'TextDocument',
  leaderModule,
  allowOverwrite: true,
};
